import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate,
         ActivatedRouteSnapshot,
         RouterStateSnapshot } from '@angular/router';
import { SettingsFormsMainEditComponent } from '../../main-edit/main-edit.component';

@Injectable({
    providedIn: 'root',
  })
export class LeaveFormEditorGuard implements CanDeactivate<SettingsFormsMainEditComponent> {
  constructor() {}

  canDeactivate(
    component: SettingsFormsMainEditComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return (!component.changesPending || component.allowLeave);
  }
}
